<template>
	<div class="global-answers">
		<div class="head">
			<md-button class="md-raised" v-on:click.native="showVoteNumbers = !showVoteNumbers" v-bind:class="{ active: showVoteNumbers }">Válaszadók számának mutatása</md-button>
		</div>

		<div class="card question" v-for="notification in notifications">
			Kérdés: {{notification.title}}</br>
			<p class="subtitle">{{notification.body}}</p>			
			<div class="card">
				<div class="option" v-for="option in notification.options">
					<p>{{option.title}}<span v-if="showVoteNumbers"> - {{option.answerCount}}</span> - {{notificationPercentage(option, notification)}}%</p>
					<div class="progress">
						<progressbar :now="notificationPercentage(option, notification)" label type="primary" striped animated></progressbar>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import FirebaseDBService from '../../services/FirebaseDBService'
	import { progressbar } from 'vue-strap'
	import * as firebase from "firebase"
	import _ from 'lodash'

	export default {
		components: {
			progressbar
		},
		data () {
			return {
				showVoteNumbers: false,
				notifications: []
			}
		},
		methods:{
			notificationPercentage(option, notification){
				return notification.answerSum > 0 ? ((option.answerCount/notification.answerSum)*100).toFixed(2) : 0;
			}
		},
		created () {
			FirebaseDBService.getNotifications((err, notifications) => {
				notifications = _.filter(notifications, (e) => {
					return e.options;
				})
				this.notifications = notifications.reverse();

				firebase.database().ref('/answers').on('value', (snapshot) => {
					for(var notification of this.notifications){
						for(var option of notification.options){
							option.answerCount = 0;
						}
					}
					console.log(snapshot.val());

					for(let userId in snapshot.val()){
						for(let questionId in snapshot.val()[userId]){
							let question = _.find(this.notifications, {fireId:questionId});
							if(question){								
								let optionIndex = parseInt(snapshot.val()[userId][questionId]);
								question.options[optionIndex].answerCount = question.options[optionIndex].answerCount + 1;
							}
						}
					}

					this.notifications = _.map(this.notifications, (notification) => {
						notification.answerSum = _.sumBy(notification.options, 'answerCount');
						return notification;
					});

					console.log(this.notifications);
				});
			});
		}
	}
</script>

<style scoped>
	.subtitle{
		font-size: 15pt;
	}
	.progress-wrapper{
		width: 100%;
	}
	.progress {
		height: auto;
		background-color: #313131;
	}
	.progress .progress-bar{
		font-size: inherit;
		line-height: inherit;
	}
	.option{
		overflow: hidden;
	}

	/* Bootstrap progress bar */

	@-webkit-keyframes progress-bar-stripes {
		from {
			background-position: 40px 0;
		}
		to {
			background-position: 0 0;
		}
	}
	@-o-keyframes progress-bar-stripes {
		from {
			background-position: 40px 0;
		}
		to {
			background-position: 0 0;
		}
	}
	@keyframes progress-bar-stripes {
		from {
			background-position: 40px 0;
		}
		to {
			background-position: 0 0;
		}
	}
	.progress {
		height: 20px;
		margin-bottom: 20px;
		overflow: hidden;
		background-color: #f5f5f5;
		border-radius: 4px;
		-webkit-box-shadow: inset 0 1px 2px rgba(0, 0, 0, .1);
		box-shadow: inset 0 1px 2px rgba(0, 0, 0, .1);
	}
	.progress-bar {
		float: left;
		width: 0;
		height: 100%;
		font-size: 12px;
		line-height: 20px;
		color: #fff;
		text-align: center;
		background-color: #337ab7;
		-webkit-box-shadow: inset 0 -1px 0 rgba(0, 0, 0, .15);
		box-shadow: inset 0 -1px 0 rgba(0, 0, 0, .15);
		-webkit-transition: width .6s ease;
		-o-transition: width .6s ease;
		transition: width .6s ease;
	}
	.progress-striped .progress-bar,
	.progress-bar-striped {
		background-image: -webkit-linear-gradient(45deg, rgba(255, 255, 255, .15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .15) 50%, rgba(255, 255, 255, .15) 75%, transparent 75%, transparent);
		background-image:      -o-linear-gradient(45deg, rgba(255, 255, 255, .15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .15) 50%, rgba(255, 255, 255, .15) 75%, transparent 75%, transparent);
		background-image:         linear-gradient(45deg, rgba(255, 255, 255, .15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .15) 50%, rgba(255, 255, 255, .15) 75%, transparent 75%, transparent);
		-webkit-background-size: 40px 40px;
		background-size: 40px 40px;
	}
	.progress.active .progress-bar,
	.progress-bar.active {
		-webkit-animation: progress-bar-stripes 2s linear infinite;
		-o-animation: progress-bar-stripes 2s linear infinite;
		animation: progress-bar-stripes 2s linear infinite;
	}
	.progress-bar-success {
		background-color: #5cb85c;
	}
	.progress-striped .progress-bar-success {
		background-image: -webkit-linear-gradient(45deg, rgba(255, 255, 255, .15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .15) 50%, rgba(255, 255, 255, .15) 75%, transparent 75%, transparent);
		background-image:      -o-linear-gradient(45deg, rgba(255, 255, 255, .15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .15) 50%, rgba(255, 255, 255, .15) 75%, transparent 75%, transparent);
		background-image:         linear-gradient(45deg, rgba(255, 255, 255, .15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .15) 50%, rgba(255, 255, 255, .15) 75%, transparent 75%, transparent);
	}
	.progress-bar-info {
		background-color: #5bc0de;
	}
	.progress-striped .progress-bar-info {
		background-image: -webkit-linear-gradient(45deg, rgba(255, 255, 255, .15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .15) 50%, rgba(255, 255, 255, .15) 75%, transparent 75%, transparent);
		background-image:      -o-linear-gradient(45deg, rgba(255, 255, 255, .15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .15) 50%, rgba(255, 255, 255, .15) 75%, transparent 75%, transparent);
		background-image:         linear-gradient(45deg, rgba(255, 255, 255, .15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .15) 50%, rgba(255, 255, 255, .15) 75%, transparent 75%, transparent);
	}
	.progress-bar-warning {
		background-color: #f0ad4e;
	}
	.progress-striped .progress-bar-warning {
		background-image: -webkit-linear-gradient(45deg, rgba(255, 255, 255, .15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .15) 50%, rgba(255, 255, 255, .15) 75%, transparent 75%, transparent);
		background-image:      -o-linear-gradient(45deg, rgba(255, 255, 255, .15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .15) 50%, rgba(255, 255, 255, .15) 75%, transparent 75%, transparent);
		background-image:         linear-gradient(45deg, rgba(255, 255, 255, .15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .15) 50%, rgba(255, 255, 255, .15) 75%, transparent 75%, transparent);
	}
	.progress-bar-danger {
		background-color: #d9534f;
	}
	.progress-striped .progress-bar-danger {
		background-image: -webkit-linear-gradient(45deg, rgba(255, 255, 255, .15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .15) 50%, rgba(255, 255, 255, .15) 75%, transparent 75%, transparent);
		background-image:      -o-linear-gradient(45deg, rgba(255, 255, 255, .15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .15) 50%, rgba(255, 255, 255, .15) 75%, transparent 75%, transparent);
		background-image:         linear-gradient(45deg, rgba(255, 255, 255, .15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .15) 50%, rgba(255, 255, 255, .15) 75%, transparent 75%, transparent);
	}
</style>


// WEBPACK FOOTER //
// Answers.vue?5e99fcf5